export default "__VITE_ASSET__BxBJOp$E__"